<header class="header__container">
  <div class="header main"
       [ngClass]="{
                'header--multiple-logos': additionalLogo,
                'header--partner-logo': additionalLogo && additionalLogo.partnerLogo,
                'main--wide': wideMainContainer
            }">
    <div *ngIf="wizardService.resolveElementVisibility(logo) && !additionalLogo"
         [ngClass]="{'header__logo--anchor': logoRedirectEnabled}"
         class="header__logo">
      <img [src]="logo.url"
           width="190"
           height="37"
           alt="KioskPolis"
           class="header__logo--img"
           (click)="navigateToLP()">
    </div>

    <div *ngIf="additionalLogo" class="header__logo">
      <a [href]="additionalLogo.url" target="_blank"
         [ngClass]="{'header__logo--no-link': !additionalLogo.url || !additionalLogoRedirectEnabled}"
         [class]="'header__logo--' + additionalLogo.alt">
        <img [src]="additionalLogo.src" [alt]="additionalLogo.alt" class="header__logo--img">
      </a>
      <a *ngIf="additionalLogoKioskPolisLogoAnchor" [href]="KioskPolisWebsiteUrl" target="_blank" class="header__logo--kp">
        <img [src]="additionalLogo.kpLogoSrc" alt="KioskPolis" class="header__logo--img">
      </a>
      <img *ngIf="!additionalLogoKioskPolisLogoAnchor" [src]="additionalLogo.kpLogoSrc" alt="KioskPolis" class="header__logo--img">
    </div>

    <div class="header__box">
      <h2 *ngIf="wizardService.resolveElementVisibility(title)" class="header__title">
        {{ title.text | translate }}
      </h2>
      <nav *ngIf="!readonly && wizardService.resolveElementVisibility(headerConfig.breadcrumb)" aria-label="breadcrumb">
        <ul class="breadcrumb">
          <ng-template *ngTemplateOutlet="breadcrumb"></ng-template>
        </ul>
      </nav>
    </div>
    <nav *ngIf="!readonly && wizardService.resolveElementVisibility(headerConfig.breadcrumb)" aria-label="breadcrumb">
      <ul class="breadcrumb breadcrumb-mobile">
        <ng-template *ngTemplateOutlet="breadcrumb"></ng-template>
      </ul>
    </nav>

    <div *ngIf="helplineWidgetVisible"
         class="header__widget">
      <app-helpline-widget [phoneNumber]="'HELPLINE_WIDGET.PHONE_NUMBER'"></app-helpline-widget>
    </div>

    <app-send-offer
            *ngIf="showOfferNumber"
            [ngClass]="{'send-offer-wrapper--with-button': sendCalculationEmailService.buttonVisible}"
            [context]="offerNumberContext"
            class="send-offer-wrapper send-offer-wrapper--header">
    </app-send-offer>
  </div>
</header>

<ng-template #breadcrumb>
  <li class="breadcrumb__item" *ngFor="let step of wizardService.stepsForNavigation; let i = index"
      [ngClass]="{
                            'active': wizardService.isActiveOrPrevious(step),
                            'breadcrumb__pointer': wizardService.shouldAllowToNavigate(step)
                         }"
      (click)="wizardService.navigateToClickedStep(step)">
    {{ i + 1 }}. {{ step.additionalInfo.stepName }}
  </li>
</ng-template>
